import React, { useEffect, useMemo, useState } from "react";
import { Box, Button, CircularProgress } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../../api/axiosInstance";
import base_url from "../../../constants";
import { WB_SX } from "../../../ui/ux/uiTokens";
import FailedMessageSummaryCard, { FAILED_SUMMARY_STATE_KEY } from "./FailedMessageSummaryCard";

const readStoredSummary = () => {
    try {
        const raw = sessionStorage.getItem(FAILED_SUMMARY_STATE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
};

const FailedMessageSummaryPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const stored = useMemo(() => readStoredSummary(), []);
    const passed = location.state?.failedSummary ? location.state : stored;
    const [failedSummary, setFailedSummary] = useState(passed?.failedSummary || []);
    const [failedTotal, setFailedTotal] = useState(passed?.failedTotal);
    const [loading, setLoading] = useState(!passed?.failedSummary);

    useEffect(() => {
        if (passed?.failedSummary) return undefined;

        let active = true;
        const load = async () => {
            try {
                const response = await axiosInstance.get(
                    `${base_url}/whatsapp-business/message-queue/statistics`
                );
                if (!active) return;
                const data = response.data?.data || {};
                setFailedSummary(data.failed_summary || []);
                setFailedTotal(data.failed);
            } catch (error) {
                console.error("Error fetching failed message summary:", error);
            } finally {
                if (active) setLoading(false);
            }
        };

        load();
        return () => {
            active = false;
        };
    }, [passed]);

    return (
        <Box sx={{ ...WB_SX.page, p: 2 }}>
            <Button
                startIcon={<ArrowBackIcon />}
                onClick={() => navigate("/whatsapp-business/message-queue")}
                sx={{ textTransform: "none", fontWeight: 700, mb: 1.5, px: 0 }}
            >
                Message queue
            </Button>
            {loading ? (
                <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
                    <CircularProgress size={28} />
                </Box>
            ) : (
                <FailedMessageSummaryCard
                    showAll
                    failedSummary={failedSummary}
                    failedTotal={failedTotal}
                />
            )}
        </Box>
    );
};

export default FailedMessageSummaryPage;
